import React from "react";
import {
  ContainerV1 as AdobeContainerV1,
  ContainerV1Properties
} from "@adobe/aem-core-components-react-spa";

// Define the props for our AEM Container component.
export interface AEMContainerComponentProps extends ContainerV1Properties {
  // Add any additional custom props here if needed
}

const AEMContainerComponent: React.FC<AEMContainerComponentProps> = props => {
  // Render the Adobe ContainerV1 component, passing all props.
  // AdobeContainerV1 handles its own editing capabilities, child rendering, and placeholder.
  return <AdobeContainerV1 {...props} />;
};

export default AEMContainerComponent;
